import { css, htmlArray } from "../helpers/webComponents";
import { GameRouteService } from "../services/GameRouteService";

/** CSS for the Locker Lock component */
const style: string = css`
    :host {
        display: block;
        font-family: "Onesize", monospace;
        padding: 20px;
        background-color: #2a2a2a;
        border: 3px solid #7f6ed7;
        border-radius: 5px;
        max-width: 600px;
        min-width: 400px;
        margin: 0 auto;
        color: #fff;
        box-shadow: 0 0 20px rgba(127, 110, 215, 0.3);
    }
    
    .locker-locker-main-container{
        width: 100%;
    }

    .title {
        text-align: center;
        font-size: 1.5em;
        margin-bottom: 20px;
        color: #7f6ed7;
        text-shadow: 0 0 5px rgba(127, 110, 215, 0.5);
    }
    
    .locker-locker-main-container input{
    width: 100%;
        padding: 12px 20px;
        border: 1px solid #7f6ed7;
    }

    .button {
        background-color: #7f6ed7;
        border: 2px solid #332c57;
        border-radius: 4px;
        padding: 12px 24px;
        margin: 0 auto;
        text-transform: uppercase;
        cursor: pointer;
        display: block;
        text-align: center;
        user-select: none;
        font-weight: bold;
        color: white;
        font-size: 16px;
        transition: all 0.2s ease;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .button:hover {
        background-color: #9a8ae8;
        transform: translateY(-2px);
        box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
    }

    .button:disabled {
        background-color: #555;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }
`;

export class LockerLockComponent extends HTMLElement {
    private inputElement: HTMLInputElement | null = null;
    // private buttonElement: HTMLElement | null = null;
    private _gameRouteService: GameRouteService = new GameRouteService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
        this.initEventListeners();
        console.log("test1");
    }

    private initEventListeners(): void {
        console.log("CctvAnalyzer initializing event listeners");
        if (this.shadowRoot) {
            console.log(this.shadowRoot);
            this.inputElement = this.shadowRoot.querySelector("input");

            if (this.inputElement) {
                // this.inputElement.addEventListener("click", () => this.handleInput());
                // on enter
                // this.inputElement.addEventListener("keydown", (event: KeyboardEvent) => {
                //     if (event.key === "Enter") {
                //         void this.handleInput();
                //     }
                // });
                // on button click
                const buttonElement: HTMLButtonElement | null = this.shadowRoot.querySelector("button");
                if (buttonElement) {
                    buttonElement.addEventListener("click", () => {
                        void this.handleInput();
                    });
                }
                console.log("Locker input event listener added");
            }
            else {
                console.error("Locker input element not found in shadowRoot");
            }
        }
        else {
            console.error("Locker input not available for event listeners");
        }
    }

    private async handleInput(): Promise<void> {
        const inputValue: string = this.inputElement?.value ?? "";
        const correct: boolean = await this._gameRouteService.checkLockerLockInput(inputValue);
        // hide if correct, don't hide if incorrect
        if (correct) {
            // this.hide();
            // refresh page
            window.location.reload();
        }
        else {
            // alert("Incorrect code");
            // flash error message
            const errorElement: HTMLParagraphElement = this.shadowRoot?.querySelector(".error") as HTMLParagraphElement;
            errorElement.style.display = "block";
            setTimeout(() => {
                errorElement.style.display = "none";
            }, 2000);
        }
    }

    private render(): void {
        const component: HTMLElement[] = htmlArray`
            <style>${style}</style> 
            <div class="locker-locker-main-container">
                <h1 class="title">Put the password of the locker</h1>
                <input placeholder="code..." type="number"></input>
                <button class="button">Submit</button>
                <p class="error" style="display: none;">Incorrect code</p>
            </div>
        `;
        this.shadowRoot?.append(...component);
        console.log("test2");
    }
}
